import { render, staticRenderFns } from "./DebitHandler.vue?vue&type=template&id=04757d35"
import script from "./DebitHandler.vue?vue&type=script&lang=js"
export * from "./DebitHandler.vue?vue&type=script&lang=js"
import style0 from "./DebitHandler.vue?vue&type=style&index=0&id=04757d35&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports